const $dt_h = document.querySelector(".dt_h");
const $dt_b = document.querySelector(".dt_b");

const setFixedHeight = () => {
  let height = 0;
  const x = $dt_b.querySelectorAll(".dt_b > div");
  x.forEach((item) => {
    const item_height = item.getBoundingClientRect().height;
    if (item_height > height) height = item_height;
  });
  $dt_b.style.height = height + "px";
};

$dt_h.addEventListener("click", (e) => {
  const $dt_h_i = e.target.closest(".dt_h div");
  if (!$dt_h_i) return;

  // Activate Tab
  const $current_active_tab = $dt_h.querySelector(".active");
  $current_active_tab?.classList.remove("active");
  $dt_h_i.classList.add("active");

  // Activate Body
  const tab = $dt_h_i.dataset.tab;
  const x = $dt_b.querySelector(`[data-tab="${tab}"]`);
  const $current_active_content = $dt_b.querySelector(".active");
  $current_active_content?.classList.remove("active");
  x.classList.add("active");
});

setFixedHeight();
